<template>
  <div>
    <div class="flex -mx-1 mb-4">
      <div class="form-group w-1/2 pl-1 pr-16">
        <label for="location_id" class="form-label">Lokacija</label>
        <input type="hidden" name="location_id" :value="(selected_location == undefined) ? '' :
                selected_location.value">
        <v-select id="location_id"
                  :filterable="false"
                  v-model="selected_location"
                  :disabled="disableEdit() || isWarehouseUser"
                  :options="location"
                  @search="locationSearch">
          <template slot="no-options">
            Pretraživanje lokacija
          </template>
        </v-select>
      </div>

      <div class="form-group w-1/2 px-1">
        <label v-if="!workOrderType" for="planned_for" class="form-label">Planirana instalacija</label>
        <label v-else for="planned_for" class="form-label">Planirano vrijeme izvršenja</label>
        <datetime
            type="datetime"
            input-id="planned_for"
            hidden-name="planned_for"
            input-class="form-control mb-1"
            :disabled="disableEdit() || isWarehouseUser"
            v-model="planned_for">
        </datetime>
      </div>
    </div>

    <div class="flex -mx-1 mb-4">
      <div class="form-group w-1/2 pl-1 pr-16">
        <label for="company_id" class="form-label">Poduzeće</label>
        <input type="hidden" name="company_id" :value="(selected_company == undefined) ? '' :
                selected_company.value">
        <v-select id="company_id"
                  :filterable="false"
                  v-model="selected_company"
                  :disabled="disableEdit() || isWarehouseUser"
                  :options="company"
                  v-on:input="installersSearch('', '')"
                  @search="companySearch">
          <template slot="no-options">
            Pretraživanje poduzeća
          </template>
        </v-select>
      </div>

      <div class="form-group w-1/2 pl-1 pr-16">
        <label for="installer_id" class="form-label">Instalater</label>
        <input type="hidden" name="installer_id" :value="(selected_installer == undefined) ? '' :
                selected_installer.value">
        <v-select id="installer_id"
                  :filterable="false"
                  v-model="selected_installer"
                  :disabled="disableInstallerSelection() || isWarehouseUser"
                  :options="installer"
                  @search="installersSearch">
          <template slot="no-options">
            Pretraživanje instalatera
          </template>
        </v-select>
      </div>
    </div>

    <div class="-mx-1 mb-4">
      <input
          id="tempFile"
          name="tempFile[]"
          style="display: none;"
          accept="application/pdf,image/png"
          type="file"
          @change="processFile($event)"
          multiple="multiple"
      />

      <div class="flex ml-1 mb-2 w-1/3" :key="'preupload-' + index" v-for="(file, index) in files">
        <a :href="file.full_url" target="_blank" class="border flex pt-3 w-full min-h-3 px-4 py-2 break-all rounded-lg">{{
            file.name
          }}</a>

        <button
            type="button"
            @click="removePreUploadFile(file, index)"
            class="flex btn btn-delete border-0 mt-2"
        ></button>
      </div>
    </div>

    <div v-if="creating" class="flex -mx-1 mt-4">
      <div class="form-group w-1/2 pl-1 pr-16">
        <div class="custom-control custom-checkbox mr-4">
          <input v-model="workOrderType" @change="changeWorkOrderType" type="checkbox" name="is_return_reverse"
                 value="1" class="custom-control-input" id="is_return_reverse">
          <label class="custom-control-label" for="is_return_reverse">Povrat opreme</label>
        </div>
        <span class="text-sm" for="is_return_reverse">Ako je povrat opreme označen gledamo opremu na stanju lokacije. U suprotnome gledamo opremu na stanju instalatera</span>
      </div>
    </div>

    <div v-if="item.is_return_reverse" class="flex -mx-1 mt-4">
      <div class="form-group w-1/2 pl-1 pr-16">
        <span class="text-xl" for="is_return_reverse">Ovaj radni nalog je za povrat opreme</span>
      </div>
    </div>

    <div class="flex -mx-1 mb-4 mt-4" v-for="(product, index) in products" :key="'product-' + index">
      <div class="form-group w-1/3 pl-1 pr-16">
        <label for="selected_product" class="form-label">Odaberi uređaj</label>
        <v-select id="selected_product"
                  :filterable="false"
                  v-model="products[index]"
                  :disabled="disableEdit()"
                  :options="allProducts"
                  @search="productsSearch">
          <template slot="no-options">
            Pretraživanje tipova opreme
          </template>
        </v-select>
      </div>
      <div class="form-group w-1/6 pl-1 pr-16">
        <label :for="'quantity-'+ index" class="form-label">Unesi količinu</label>
        <input type="number"
               class="form-control"
               :id="'quantity-'+ index"
               :disabled="disableEdit()"
               v-model="products[index].quantity">
      </div>

      <div class="form-group w-1/6 pl-1 pr-16">
        <label :for="'quantity-'+ index" class="form-label">Dodano</label>
        <span>{{ product.qr_codes.length }} / {{ products[index].quantity }}</span>
      </div>

      <div>
        <span v-if="product.qr_codes.length > 0">Unosi:</span><br>
        <span v-for="(qrCode, qrIndex) in product.qr_codes" :key="'entries-' + qrIndex">
                    <div>
                        <div class="flex flex-col">
                            <div>
                                <strong>QR:</strong> {{ qrCode.code }}
                            </div>
                            <div v-if="qrCode.serial_no != ''">
                                <strong>S/N:</strong> {{ qrCode.serial_no }}
                            </div>
                            <span v-if="product.mac_addresses > 0">
                                <strong>MAC:</strong> {{ qrCode.mac_address }}
                            </span>
                            <span v-if="product.mac_addresses > 1">
                                <strong>MAC2:</strong> {{ qrCode.mac_address2 }}
                            </span>
                        </div>

                        <div v-if="!hideInstalled && isAbleToEdit" class="flex mt-2">
                            <button
                                class="review-link mr-2"
                                :disabled="disableEdit()"
                                @click.prevent="removeQr(index, qrIndex)"
                            >
                                Ukloni QR
                            </button><br>
                            <handle-file :name="'file-' + qrCode.code" :qr="qrCode.code"></handle-file>
                        </div>
                        <hr class="m-4">
                    </div>
                </span>
      </div>

      <div v-if="!lessThanTwo() && !hideInstalled" class="ml-auto">
        <label :for="'remove-product-' + index" class="">&nbsp;</label>
        <button
            :id="'remove-product-' + index"
            type="button"
            class="btn btn-delete border-0 my-0 py-0 px-2 hover:text-primary flex"
            @click="removeProduct(index)"
        >Ukloni uređaj
        </button>
      </div>
    </div>

    <div v-if="!hideInstalled" class="form-group w-full px-1 bg-gray-100">
      <div class="flex w-full items-end my-8">
        <div class="flex flex-col items-start w-3/5 pl-8">
          <label for="equipmentQr" class="form-label pr-6 mb-1 text-sm text-text">Unos QR koda ili serijskog
            broja</label>
          <v-select id="equipmentQr"
                    :filterable="false"
                    v-model="selectedEquipmentQr"
                    :options="equipmentQr"
                    :disabled="disableQrSelection()"
                    @search="qrCodeSearch">
            <template slot="no-options">
              Unesite QR code sa opreme
            </template>
          </v-select>
        </div>
        <div class="flex w-1/5 justify-center items-center ml-2 mb-1">
          <button class="btn btn-lg btn-success btn-add-equipment" :disabled="!equipmentSelected()"
                  @click.prevent="addEquipment()">
            <span>Dodaj opremu</span>
          </button>
        </div>
      </div>
    </div>

    <span v-for="(product, index) in products" :key="'products-' + index">
            <input type="hidden" :name="'products[' + index + '][id]'"
                   :value="product.value">
            <input type="hidden" :name="'products[' + index + '][quantity]'"
                   :value="product.quantity">
            <span v-for="(qrCode, qrIndex) in product.qr_codes" :key="'product-qr-' + qrIndex">
                <input type="hidden" :name="'products[' + index + '][qr_codes][' + qrIndex + '][id]'"
                       :value="qrCode.value">
            </span>
        </span>

    <div v-if="!hideInstalled" class="flex -mx-1 mb-4 mt-8 justify-between">
      <button class="btn btn-lg btn-success btn-yellow ml-1" :disabled="disableEdit()"
              @click.prevent="addNewProduct()">
        <span>Dodaj novi uređaj</span>
      </button>
    </div>

    <hr v-if="!hideInstalled">

    <div class="flex -mx-1 mb-4">
      <div class="form-group w-full px-1">
        <div class="flex w-full mb-3" v-for="(item, index) in preparations" :key="'preparations-' + index">
          <div class="flex inline-flex items-center w-1/4 px-1 mt-8">
            <label :for="'preparation-'+ index" class="form-label pt-2">Neophodno</label>
            <input :id="'preparation-'+ index" type="checkbox" class="ml-2"
                   v-model="preparations[index]['required_before']"
                   :disabled="disableEdit() || item.finished">
          </div>
          <div class="form-group w-2/4 px-1">
            <label class="form-label">Naziv</label>
            <input type="text" class="form-control" v-model="preparations[index]['title']"
                   :disabled="disableEdit() || item.finished">
          </div>
          <div v-if="!hideInstalled" class="form-group w-1/4 px-1 flex justify-center">
            <button
                type="button"
                class="btn btn-delete ml-4 mt-8 cancel hover:text-primary"
                :disabled="disableEdit() || item.finished"
                @click="removePreparation(item)">Ukloni predradnju
            </button>
          </div>
          <div v-if="!hideInstalled && !item.finished && showCompletePreparationButton"
               class="form-group w-1/4 px-1 flex justify-center">
            <button
                :disabled="!isAbleToEdit"
                type="button"
                class="btn btn-edit border-hl_yellow ml-4 mt-8 hover:text-primary"
                @click="completePreparation(item)">Potvrdi predradnju
            </button>
          </div>
          <div v-if="item.finished" class="form-group ml-2 w-1/4 px-1 flex justify-center">
            <span class="mt-8">Izvršeno</span>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!hideInstalled" class="flex -mx-1 mb-4">
      <div class="form-group col-1 d-flex">
        <button
            type="button"
            class="btn btn-success btn-yellow mt-2 ml-1"
            :disabled="disableEdit()"
            @click="addPreparation()">Dodaj predradnju
        </button>
      </div>
    </div>

    <span v-for="(value, index) in preparations" :key="'preparation-' + index">
            <input type="hidden" :name="'preparations[' + index + '][title]'"
                   :value="value.title">
            <input type="hidden" :name="'preparations[' + index + '][required_before]'"
                   :value="value.required_before">
            <input type="hidden" :name="'preparations[' + index + '][id]'"
                   :value="value.id">
        </span>
  </div>
</template>

<script>
import Vue from 'vue'
import vSelect from 'vue-select'
import {Datetime} from 'vue-datetime'
import {Settings} from 'luxon'
import axios from 'axios'
import HandleFile from './HandleFile'

Vue.component('v-select', vSelect)
Vue.component('datetime', Datetime);
Settings.defaultLocale = 'hr'

export default {
  components: {
    HandleFile,
  },

  props: {
    creating: {
      type: Boolean,
      required: false,
      default: false,
    },
    isWarehouseUser: {
      type: Boolean,
      default: false,
    },
    isNetworkUser: {
      type: Boolean,
      default: false,
    },
    isLead: {
      type: Boolean,
      default: false,
    },
    oldFiles: {
      type: Array,
      required: false,
      default: () => {
        return []
      },
    },
    showOldFile: {
      type: Boolean,
      default: false,
    },
    productsAndQr: {
      type: Array,
      default: () => ([])
    },
    item: {
      type: Object,
      default: () => ({})
    },
    selectedLocation: {
      type: Object,
      default: () => ({})
    },
    selectedInstaller: {
      type: Object,
      default: () => ({})
    },
    selectedCompany: {
      type: Object,
      default: () => ({})
    },
    wPreparations: {
      type: Array,
      default: () => ([])
    },
    plannedFor: {
      type: String,
      default: null
    },
    plannedEnd: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      workOrderType: false,
      hideInstalled: false,
      location: [],
      installer: [],
      company: [],
      preparations: [],
      equipmentQr: [],
      allProducts: [],
      products: [],
      selectedEquipmentQr: null,
      selected_company: null,
      planned_for: null,
      planned_end: null,
      itemData: null,
      selected_installer: null,
      selected_location: null,
      files: [],
      showFiles: this.showOldFile,
      preparationsDone: false,
      showCompletePreparationButton: false,
      isAbleToEdit: true,
      excludeCodes: []
    }
  },
  created() {
    if (this.item.status == 'install_ready' && (this.isWarehouseUser)) {
      this.isAbleToEdit = false
    }
    this.selected_installer = this.selectedInstaller;
    this.selected_location = this.selectedLocation;
    this.selected_company = this.selectedCompany;
    this.preparations = this.wPreparations;
    this.planned_for = this.plannedFor;
    this.planned_end = this.plannedEnd;
    this.itemData = this.item;
    this.products = this.productsAndQr;
    this.workOrderType = this.item.is_return_reverse

    this.products.forEach((item) => {
      if (item.qr_codes.length > 0) {
        item.qr_codes.forEach((eq) => {
          if (eq.code && eq.code != '') {
            this.excludeCodes.push(eq.code)
          } else {
            this.excludeCodes.push(eq.serial_no)
          }
        })
      }
    })

    this.initProducts()
  },
  mounted() {
    if (this.item.status == 'installed' || this.item.status == 'installed_at') {
      this.hideInstalled = true
    }

    if (this.item.status == 'install_ready') {
      this.showCompletePreparationButton = true
    }

    this.locationSearch('', '')
    this.initialInstallersSearch('', '')
    this.companySearch('', '')
    this.productsSearch('', '')

  },
  methods: {
    removeQr(index, qrIndex) {
      let qrItem = this.products[index]['qr_codes'][qrIndex]

      this.products[index]['qr_codes'].splice(qrIndex, 1);

      let excludeIndex = this.excludeCodes.indexOf(qrItem.code)

      if (excludeIndex > -1) {
        this.excludeCodes.splice(excludeIndex, 1)
      }
    },

    changeWorkOrderType() {
      console.log(this.workOrderType)
    },

    lessThanTwo() {
      return this.products.length < 2
    },

    removeProduct(index) {
      this.products.splice(index, 1)
    },

    processFile($event) {
      if (this.files.length == 0) {
        this.files = this.toArray($event.target.files)
        return
      }

      this.files = this.toArray(this.files).concat(this.toArray($event.target.files))
    },

    toArray(fileList) {
      return Array.prototype.slice.call(fileList);
    },

    chooseFile() {
      let element = 'tempFile'
      document.getElementById(element).click()
    },

    removePreUploadFile(file, index) {
      this.files.splice(index, 1)
    },

    removeFile(file) {
      axios.get(route('admin.delete.document'))
          .then((response) => {
            document.querySelector('#file-' + file.id).remove()
          })
          .catch((error) => {
            console.error(error);
          });
    },

    initProducts() {
      if (this.products.length === 0) {
        this.addNewProduct()
      }
    },

    addNewProduct() {
      this.products.push({
        label: '',
        value: null,
        quantity: 0,
        mac_addresses: 0,
        qr_codes: [],
      });
    },

    qrCodeSearch(search, loading) {
      this.isInSearchLoading = true;
      if (!this.workOrderType) {
        axios.get(route('admin.api.search.work-order.equipment', {
          location: this.selected_installer.value,
          code: search,
          exclude: this.excludeCodes,
        }))
            .then((response) => {
              this.equipmentQr = response.data.data;
              this.isInSearchLoading = false;
            })
            .catch((error) => {
              console.error(error);
            });
      } else {
        axios.get(route('admin.api.search.qr-code', {
          location: this.selected_location.value,
          code: search,
          exclude: this.excludeCodes,
        }))
            .then((response) => {
              this.equipmentQr = response.data.data;
              this.isInSearchLoading = false;
              console.log(response.data)
            })
            .catch((error) => {
              console.error(error);
            });
      }
    },

    equipmentSelected() {
      return this.selectedEquipmentQr
    },

    productsSearch(search, loading) {
      this.isInSearchLoading = true;

      fetch('/api/all-products/' + escape(search))
          .then(res => res.json())
          .then(json => {
            this.allProducts = json.data;
            this.isInSearchLoading = false;
          })
          .catch(err => console.warn(err));
    },

    locationSearch(search, loading) {
      this.isSearchLoading = true;

      fetch('/api/search/work-order-locations/' + escape(search))
          .then(res => res.json())
          .then(json => {
            this.location = json.data;
            this.isSearchLoading = false;
          })
          .catch(err => console.warn(err));
    },

    companySearch(search, loading) {
      this.isSearchLoading = true;

      fetch('/api/search/companies/' + escape(search))
          .then(res => res.json())
          .then(json => {
            this.company = json.data;
            this.isSearchLoading = false;
          })
          .catch(err => console.warn(err));
    },

    clearInstallerSelection() {
      this.selected_installer = '';
    },

    installersSearch(search, loading) {
      this.isInSearchLoading = true;

      fetch('/api/search/installers/' + this.selected_company.value + '/' + escape(search))
          .then(res => res.json())
          .then(json => {
            this.installer = json.data;
            this.isInSearchLoading = false;
          })
          .catch(err => console.warn(err));
    },

    initialInstallersSearch(search, loading) {
      this.isInSearchLoading = true;
      fetch('/api/search/installers/' + this.selected_company.value + '/' + escape(search))
          .then(res => res.json())
          .then(json => {
            this.installer = json.data;
            this.isInSearchLoading = false;
          })
          .catch(err => console.warn(err));
    },

    addEquipment() {
      let arrayLength = this.products.length;
      for (let i = 0; i < arrayLength; i++) {
        if (this.products[i]['value'] == this.selectedEquipmentQr.product_id) {
          if (this.products[i]['qr_codes'].length == this.products[i]['quantity']) {
            alert('Već su dodani svi QR kodovi za ' + this.products[i]['label']);
          } else if (this.products[i]['qr_codes'].length > this.products[i]['quantity']) {
            alert('Već je dodano previše QR kodova za ' + this.products[i]['label']);
          } else {
            this.equipmentQr = []

            // Adding all the selected QR-s to a exclude array and send it with the request
            if (this.selectedEquipmentQr.code && this.selectedEquipmentQr.code != '') {
              this.excludeCodes.push(this.selectedEquipmentQr.code)
            } else {
              this.excludeCodes.push(this.selectedEquipmentQr.serial_no)
            }

            this.products[i]['qr_codes'].push({
              label: this.selectedEquipmentQr.label,
              value: this.selectedEquipmentQr.value,
              code: this.selectedEquipmentQr.code,
              serial_no: this.selectedEquipmentQr.serial_no,
              mac_address: this.selectedEquipmentQr.mac_address,
              mac_address2: this.selectedEquipmentQr.mac_address2,
            });
          }
        }
      }

      this.selectedEquipmentQr = null
    },

    disableEdit() {
      if (
          this.itemData.status == 'draft' ||
          this.itemData.status === undefined ||
          (
              this.isLead &&
              this.itemData.status != 'installed_at' &&
              this.itemData.status != 'installed'
          )
      ) {
        return false
      }

      return true
    },

    disableQrSelection() {
      if (this.itemData.status == 'installed_at' || this.itemData.status == 'installed' || !this.selected_installer.value) {
        return true
      }

      return false
    },

    disableInstallerSelection() {
      if (this.disableEdit() || !this.selected_company.value) {
        return true
      }

      return false
    },

    addPreparation() {
      this.preparations.push({
        title: '',
        required_before: '',
      })
    },

    removePreparation(item) {
      this.preparations = this.preparations.filter((value, index) => {
        return item != value
      })
    },

    completePreparation(item) {
      axios.get(route('admin.complete.preparation', item))
          .then((response) => {
            this.preparations.forEach((preparation) => {
              if (preparation.id == item.id) {
                preparation.finished = true
              }
            })
            console.log(response.data)
          })
          .catch((error) => {
            console.error(error);
          });
    }
  },
}
</script>
